import { SWEEPS_MERCHANT_LOGOS_GET_SUCCESS, SWEEPS_MERCHANT_LOGOS_GET_FAILURE } from '../actions/types';
import config from '../configs';

const initialState = {
  config,
  isLoading: false,
  isLoaded: false,
  placements: [],
};

const sweepsMerchantLogos = (state = initialState, action) => {
  switch (action.type) {
    case SWEEPS_MERCHANT_LOGOS_GET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        placements: action.payload.response,
      };
    }
    case SWEEPS_MERCHANT_LOGOS_GET_FAILURE: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        placements: [],
      };
    }
    default: {
      const { options = {} } = action;

      if (options.success === SWEEPS_MERCHANT_LOGOS_GET_SUCCESS) {
        return {
          ...state,
          isLoading: true,
          isLoaded: false,
        };
      }

      return state;
    }
  }
};

export default sweepsMerchantLogos;
